import Box, { BoxProps } from "@mui/material/Box";
import { ConfirmDialog, MenuItem, MoreHorizMenu } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { rightPaneStore, routerStore } from "csi/state/rootStore";
import xml from "csi/xml";
import React, { FunctionComponent } from "react";

interface Props extends BoxProps {
	/** Slack channel Id */
	channelId: string;

	/** type of node being connected to this channel */
	nodeType?: string;

	/** callback to when the user selects 'Remove connection to channel' */
	onRemoveConnectionToChannel?: (channelId: string) => void;
}

const ChannelMenu: FunctionComponent<Props> = (props) => {
	const {
		channelId,
		nodeType,
		onRemoveConnectionToChannel,
		...otherProps
	} = props;

	const locale = useLocale();
	const type = locale.type(nodeType);
	const node = routerStore.locationNode;
	const isNodeReadOnly = !xml.nodeHasAccess(node, xml.RIGHT_WRITE);

	/** Open the channel in Slack app */
	const handleOpenInSlack = () => {
		window.open("https://slack.com/app_redirect?channel=" + channelId, "_blank");
	};

	/** Remove connection to channel */
	const handleRemoveConnectionToChannel = () => {
		rightPaneStore.openDialog(ConfirmDialog, {
			category: "warn",
			confirmRes: "Remove",
			messageRes: "RemoveConnectionToChannel_Confirm",
			messageResParams: [type],
			titleRes: "RemoveConnectionToChannel_Prompt",
			onConfirm: () => onRemoveConnectionToChannel?.(channelId),
		});
	};

	return (
		<Box {...otherProps}>
			<MoreHorizMenu>
				<MenuItem onClick={handleOpenInSlack} res="OpenInSlack" />
				{!isNodeReadOnly &&
					<MenuItem onClick={handleRemoveConnectionToChannel} res="RemoveConnectionToChannel" />
				}
			</MoreHorizMenu>
		</Box>
	);
};

export default ChannelMenu;